module.exports = __webpack_public_path__ + "static/media/hide.5c8bb2d7.svg";